import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { withLocale } from '@dietlabs/components';
import Layout from 'Layout/Layout';

export class ShoppingCartThankYouComponent extends React.Component {
    render() {
        return (
            <Layout page="thnk-you">
                <section className="hero">
                    <Container>
                        <Row>
                            <Col>
                                <h1>{this.props.t('thank-you/title')}</h1>
                            </Col>
                        </Row>
                    </Container>
                </section>
                {this.props.children}
            </Layout>
        );
    }
}

ShoppingCartThankYouComponent.propTypes = {
    t: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default withLocale(ShoppingCartThankYouComponent);
